module.exports = __webpack_public_path__ + "img/sec-7_icon-gen.bcbdcaf2.svg";